function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:useCurrent;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M370.53,466.32c.27-.12.52-.26.78-.4s.55-.27.82-.42.73-.41,1.08-.62l.47-.27c.45-.27.89-.56,1.33-.85l.17-.12A36.05,36.05,0,0,0,391,433.44a35.55,35.55,0,0,0-10.86-25.07l-.05-.06c-.39-.38-.79-.75-1.2-1.12l-.1-.09c-.41-.37-.83-.72-1.25-1.07l-.09-.07a37,37,0,0,0-23.26-8.33H296.48a3.4,3.4,0,0,0-3.4,3.4v15.12a3.4,3.4,0,0,0,3.4,3.4h21.16a2.84,2.84,0,0,1,2.69,3.69A36,36,0,0,0,318.85,436c0,.71.1,1.4.19,2.09a8.49,8.49,0,0,1-4.32,8.35A12.53,12.53,0,0,0,308.46,458a12.67,12.67,0,0,0,12.48,11.94A12.48,12.48,0,0,0,329,467a8.78,8.78,0,0,1,9.61-1,35.63,35.63,0,0,0,13.42,3.77,36.07,36.07,0,0,0,16.84-2.71l.4-.18C369.71,466.7,370.12,466.52,370.53,466.32Z",
  transform: "translate(-293.08 -397.63)"
});

function SvgButtonRow3RightSticker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 97.96 72.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonRow3RightSticker);
export default __webpack_public_path__ + "static/media/button-row-3-right-sticker.b0fa20ed.svg";
export { ForwardRef as ReactComponent };